import { Link, makeStyles, Typography } from '@material-ui/core';
import React from 'react';


const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.spacing(80),
    margin: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  errorScreenshotImg: {
    height: 'auto',
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginLeft: 0,
    },
  },
  troubleshootingBlock: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  clearBoth: {
    clear: 'both',
  }
}));

export const TroubleshootingPage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h5" className={classes.title}>
        Troubleshooting
      </Typography>


      <Typography variant="h6" className={classes.title}>
        .NET Framework Initialization Error
      </Typography>

      <div className={classes.troubleshootingBlock}>
        <Typography>
          This happens if you do not have the <b>.NET Framework 4</b> installed.
          You can download it here:{" "}
          <Link target="_blank" href="https://www.microsoft.com/en-us/download/details.aspx?id=17851">https://www.microsoft.com/en-us/download/details.aspx?id=17851</Link>
        </Typography>
        <img src="/screenshots/net-framework-error.png" alt=".NET Framework Initialization Error" className={classes.errorScreenshotImg} />

      </div>

      <Typography variant="h6" className={classes.title}>
        The embedded browser failed to initialize
      </Typography>

      <div className={classes.troubleshootingBlock}>
        <Typography>
          This happens if you do not have the <b>Visual C++ Redistributable for Visual Studio 2015</b> installed.
          You can download it here:{" "}
          <Link target="_blank" href="https://www.microsoft.com/en-us/download/details.aspx?id=48145">https://www.microsoft.com/en-us/download/details.aspx?id=48145</Link>
        </Typography>
        <img src="/screenshots/vc-redis-error.png" alt="The embedded browser failed to initialize" className={classes.errorScreenshotImg} />
      </div>
      <div className={classes.clearBoth}></div>
    </div>
  );
};
